import { MutableRefObject } from "react";
import { getRenderingEngine, eventTarget } from "@cornerstonejs/core";
import * as cornerstoneTools from "@cornerstonejs/tools";
import { addSphere } from "../vtk/sphere";

const { Enums: csToolsEnums } = cornerstoneTools;

export const setupEventListeners = (sphereActorRef: MutableRefObject<any>) => {
  // Create the event handler function
  const handleMouseClick = (evt: any) => {
    const { toolCenter } = evt.detail;
    const renderingEngine = getRenderingEngine("myRenderingEngine");
    if (!renderingEngine) return;

    const viewport = renderingEngine.getViewport("CT_3D_VOLUME");
    if (viewport && sphereActorRef.current && toolCenter) {
      addSphere(
        viewport,
        sphereActorRef,
        toolCenter as [number, number, number]
      );
    }
  };

  // Add event listener for crosshair tool center changes
  eventTarget.addEventListener(csToolsEnums.Events.MOUSE_CLICK, handleMouseClick);

  return () => {
    // Cleanup function to remove event listeners
    eventTarget.removeEventListener(csToolsEnums.Events.MOUSE_CLICK, handleMouseClick);
  };
};
